import React from 'react';
import { ButtonContainer } from '../styled/Button';

const SearchRooms = ({ query, setQuery }) => { 
    return (
            <div>
                <input 
                    className='caret-white border p-2 rounded-xl  bg-transparent pr-10 lg:w-[120px] lg:placeholder:text-xs lg:text-xs' 
                    type="text" 
                    placeholder='Buscar' 
                    // value={ query } 
                    // onChange={(e) => setQuery(e.target.value) }
                    style={{}}
                    >
                </input>
                
                <button className='text-2xl fa fa-search absolute top-7 right-14 lg:top-6 lg:text-sm' />

            </div>
    );
};

export default SearchRooms;